<template>
  <router-view />
</template>
<script>
import utils from '@/utils/utils'
import '@/style/scss/auth.scss'
export default {
  created() {
    this.hideShare()
  },
  methods: {
    hideShare() {
      utils.hideShare()
    }
  }
}

</script>
